import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React from "react";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {config} from "../../../constant";

export default function DialogEditMail({open, onClose}) {
    const validationSchema = Yup.object().shape({
        recipient: Yup.string().required("Destinataire est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            recipient: ''
        }
    });

    const onSubmit = (data) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        fetch(`${config.BASE_URL}/mail/nominations`, requestOptions)
            .then(() => {
                console.log('Envoi OK');
                onClose();
            })
            .catch((error) => {
                console.error('Erreur dans l\'envoi des notifications par mail', error);
            });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth={'lg'}>
            <DialogTitle>Envoi par mail</DialogTitle>
            <DialogContent>
                <form id="mailForm" onSubmit={handleSubmit(onSubmit)}>
                    <TextField
                        margin="dense"
                        id="recipient"
                        name="recipient"
                        label="Destinataire"
                        fullWidth
                        variant="standard"
                        {...register("recipient")}
                        error={!!errors.recipient}
                    />
                    <Typography variant="inherit" color="textSecondary">{errors.recipient?.message}</Typography>
                </form>
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="mailForm">OK</Button>
                <Button onClick={onClose}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
